/** Move-armed geometry on the map. Named in the detail help text. */
export const REVIEW_ENTRY_MOVE_COLOR = '#ea580c'
export const REVIEW_ENTRY_MOVE_COLOR_LABEL = 'orange'
